<template>
  <div>
    <div v-for="field in local_props.filter_list">
      <FilterGeneric
        :ref="field.id"
        :field="field"
        :disabled="disabled"
        @update="update_filter"
      ></FilterGeneric>
    </div>
  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import "@/sass/modalform.scss";
</style>
  
  
<script>
  import { QFilters, get_qfilter } from '@/qunit/filters';
  import FilterGeneric from '@/components/explorer/filters/FilterGeneric';
  export default {
    components: {
      FilterGeneric,
    },
  
    name: 'FilterList',
  
    props: {
      filters: {
        type: QFilters,
        required: true,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      is_mobile: {
        type: Boolean, 
        default: false
      },
      filter_list: {
      },
      props: {
        default: () => ({})
      }
    },
  
    data: () => ({
      local_props: {},
      local_values: {},
    }),
  
    computed: {
      filter_form() {
        return this.filter_list || this.props.filter_list || [];
      },
      
    },
  
    mounted() {
      this.update_filters_values();
    },
  
    methods: {
      get_value() {
        let res = new QFilters();
        for (const filter of this.local_props.filter_list) {
          if (!!this.$refs[filter.id]) {
            res.set_filter(get_qfilter(filter.id,this.local_values[filter.id]));
          }
        }
        return res;
      },

      update_filters_values() {
        let list = []
        for(const filter of this.filter_form) {
          let field = {...filter};
          if (this.filters.get_filter(filter.id)) {
            field.value = this.filters.get_filter_value(filter.id);
          } else {
            field.value = undefined;
          }
          list.push(field);
          this.local_values[filter.id] = field.value;
        }
        this.local_props = {...this.props,filter_list: list};
      },

      update_filter(filter) {
        this.local_values[filter.name] = filter.value;
        this.$emit('update',filter)
      },
    },
  
    watch: {
      filters() {
        this.update_filters_values();
      },
      filter_list() {
        this.update_filters_values();
      },
      props() {
        this.update_filters_values();
      }
    }
  }
</script>
  